export default "__VITE_ASSET__53934c24__"